(function () {
  'use strict';

  angular.module('mousewheelDirectiveModule', []);
}());
